<template>
  <!-- Old bit.dev component -->
  <div class="c-base-financial-summary">
    <div
      @click="toggle"
      :class="{ 'c-base-financial-summary--header-show': show }"
      class="c-base-financial-summary__header clearfix has-text-white"
    >
      <div
        :class="{ 'c-base-financial-summary--left-show': show }"
        class="c-base-financial-summary__left has-background-support"
      >
        <div
          class="c-base-financial-summary__content c-base-financial-summary--content-header has-text-white"
        >
          <p v-if="show">Resumo das transações</p>
          <p v-else>Valor disponível</p>
        </div>
      </div>
      <div
        :class="{
          'c-base-financial-summary--right-show': show,
          'has-background-error': available < 0,
        }"
        class="c-base-financial-summary__right has-background-supportdark"
      >
        <div class="c-base-financial-summary__content">
          <strong class="has-text-white">{{ available | currency }} </strong>
        </div>
      </div>
      <div
        :class="{ 'c-base-financial-summary--toggle-rotate': show }"
        class="c-base-financial-summary__toggle"
      >
        <span class="icon">
          <!-- Use this slot to set icon toggle -->
          <slot name="icon-toggle"></slot>
        </span>
      </div>
    </div>
    <div
      :class="{ 'c-base-financial-summary--body-show': show }"
      class="c-base-financial-summary__body clearfix has-background-grey-lighter"
    >
      <div class="c-base-financial-summary__left margin-top">
        <div
          class="c-base-financial-summary__content c-base-financial-summary__content-body c-base-financial-summary--content-right"
        >
          Total recebido:
        </div>
        <div
          class="c-base-financial-summary__content c-base-financial-summary__content-body c-base-financial-summary--content-right"
        >
          Total aguardando liberação:
          <!-- Use this slot to set icon information -->
          <slot name="icon-information"></slot>
        </div>
        <div
          class="c-base-financial-summary__content c-base-financial-summary__content-body c-base-financial-summary--content-right"
        >
          Total utilizado:
        </div>
        <div
          class="c-base-financial-summary__content c-base-financial-summary__content-body c-base-financial-summary--content-right margin-bottom"
        >
          Total disponível para uso:
        </div>
      </div>
      <div class="c-base-financial-summary__right has-text-right margin-top">
        <div
          class="c-base-financial-summary__content c-base-financial-summary__content-body"
        >
          <base-financial-summary-reload v-if="received === -1">
            <!-- Set this slot to set icon to icon reload page -->
            <slot name="icon-reload"></slot>
          </base-financial-summary-reload>
          <strong v-else class="has-text-black">{{
            received | currency
          }}</strong>
        </div>
        <div
          class="c-base-financial-summary__content c-base-financial-summary__content-body"
        >
          <base-financial-summary-reload v-if="pending === -1">
            <slot name="icon-reload"></slot>
          </base-financial-summary-reload>
          <strong v-else class="has-text-grey">{{ pending | currency }}</strong>
        </div>
        <div
          class="c-base-financial-summary__content c-base-financial-summary__content-body"
        >
          <base-financial-summary-reload v-if="used === -1">
            <slot name="icon-reload"></slot>
          </base-financial-summary-reload>
          <strong v-else class="has-text-error">{{ used | currency }}</strong>
        </div>
        <div
          class="c-base-financial-summary__content c-base-financial-summary__content-body margin-bottom"
        >
          <base-financial-summary-reload v-if="available === -1">
            <slot name="icon-reload"></slot>
          </base-financial-summary-reload>
          <strong
            v-else
            :class="{ 'has-text-error': available < 0 }"
            class="has-text-support"
            >{{ available | currency }}</strong
          >
        </div>
      </div>
      <div class="c-base-financial-summary btn-acessar-shopping">
        <button
          @click="userValidateToRedirect('shopping')"
          :disabled="!walletSummary.owner_cpf"
          type="button"
          class="button is-primary"
        >
          Acessar Shopping
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseFinancialSummaryReload from '@/components/Wallet/BaseFinancialSummaryReload.vue'

import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'

export default {
  mixins: [verifyDataUserMixin],

  components: {
    BaseFinancialSummaryReload,
  },
  props: {
    // Total value received
    received: {
      type: Number,
      default: 0,
    },
    // Total value pending
    pending: {
      type: Number,
      default: 0,
    },
    // Total value used
    used: {
      type: Number,
      default: 0,
    },
    // Total value available
    available: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      // Defines whether summary is opened or not
      show: false,
    }
  },

  computed: {
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },
  },

  methods: {
    // Toggle show
    toggle() {
      this.show = !this.show
    },

    // Function from verifyDataUserMixin
    userValidateToRedirect(params) {
      if (this.verifyDataUser()) {
        this.goTo(params)
      } else {
        this.$refs.CPFModalPix.open()
      }
    },
  },
}
</script>

<style lang="scss">
.c-base-financial-summary {
  @include position(fixed, auto, 0, 0, 0);
  margin: 0 auto;

  &__header {
    position: relative;
    cursor: pointer;
    overflow: hidden;
    transition: 0.3s all ease;
  }

  &__toggle {
    @include position(absolute, 50%, 12px, auto, auto);
    margin-top: -13px;
    height: 24px;
    border: none;
    outline: none;
    cursor: pointer;
    transition: 0.5s all ease;
    transition-delay: 0.3s;
    background-color: transparent;
  }

  &--toggle-rotate {
    margin-top: -10px;
    transform: rotate(180deg);
  }

  &__body {
    max-height: 0;
    height: 0;
    opacity: 0;
    overflow: hidden;
    visibility: hidden;
    transition: 0.5s all ease;
  }

  &--body-show {
    max-height: 100vh;
    height: auto;
    opacity: 1;
    overflow: auto;
    visibility: visible;
  }

  &__left {
    float: left;
    width: calc(100% - 142px);
    clear: left;
  }

  &__right {
    float: left;
    width: 142px;
  }

  &__content {
    display: flex;
    padding: 0 9px;
    align-items: center;
    height: 40px;
    .icon {
      margin-left: 6px;
    }
    > button {
      font-size: 14px;
      padding: 18px;
    }
    &-body {
      height: 30px !important;
    }
  }

  &--content-big {
    height: 60px;
    align-items: flex-start;
  }

  &--content-right {
    justify-content: flex-end;
  }

  @media (min-width: $tablet) {
    bottom: 18px;
    max-width: 530px;
    margin: 0 auto;

    &__header,
    &__body {
      overflow: hidden;
      box-shadow: 0 7px 10px 0 rgba(132, 147, 162, 0.18);
    }

    &__header {
      border-radius: 35px;
    }

    &--header-show {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      box-shadow: none;
    }

    &__body {
      border-bottom-right-radius: 35px;
      border-bottom-left-radius: 35px;
      border: 1px solid $gray-2;
    }

    &__toggle {
      right: 18px;
    }

    &__content {
      padding: 0 18px;
      height: 60px;
      font-size: 1.1em;
    }

    &__left {
      width: calc(100% - 200px);
    }

    &__right {
      width: 200px;
    }
  }

  &--content-header {
    padding-left: 24px;
  }

  &--left-show {
    width: 100%;
  }

  &--right-show {
    display: none;
  }

  .tooltip.is-tooltip-multiline::before {
    text-align: center;
    min-width: 15rem;
  }

  .margin-bottom {
    margin-bottom: 17px;
  }

  .margin-top {
    margin-top: 17px;
  }

  .btn-acessar-shopping {
    width: 280px;
    display: block;
    position: inherit;
    margin-bottom: 10px;
    text-align: center;
  }
}
</style>
